import { DocumentKind, DunningStage } from './types.js';
const KIND_LABELS = {
    [DocumentKind.INVOICE]: 'Rechnung',
    [DocumentKind.CREDIT_NOTE]: 'Stornorechnung',
    [DocumentKind.DUNNING_LETTER]: 'Mahnung',
    [DocumentKind.HONORARVEREINBARUNG]: 'Honorarvereinbarung',
    [DocumentKind.GKV_BEGLEITZETTEL]: 'Begleitzettel für Urbelege',
    [DocumentKind.GKV_PARAGRAF_18_MITTEILUNG]: 'Mitteilung nach § 18',
};
export function kindLabel(kind) {
    return KIND_LABELS[kind];
}
const DUNNING_STAGE_LABELS = {
    [DunningStage.PAYMENT_REMINDER]: 'Zahlungserinnerung',
    [DunningStage.FIRST_NOTICE]: '1. Mahnung',
    [DunningStage.FINAL_NOTICE]: '2. Mahnung',
};
export function dunningStageLabel(stage) {
    return DUNNING_STAGE_LABELS[stage];
}
const PAYER_DOMAIN_LABELS = {
    pkv: 'PKV',
    self_pay: 'Selbstzahler',
};
/**
 * Maps a payer domain code (as snapshotted on the invoice) to its German UI
 * label. Returns a neutral fallback for `null` (legacy drafts) or unknown
 * codes. Scope today is `pkv | self_pay`; GKV is intentionally not included.
 */
export function payerLabel(code) {
    if (code === null || code === undefined)
        return '—';
    return PAYER_DOMAIN_LABELS[code] ?? code;
}
//# sourceMappingURL=labels.js.map